import React from 'react';
import styles from './Experience.module.css';

const Experience: React.FC = () => {
  return (
    <div className={styles.experience}>
      <h2>Skills</h2>
      <div className={styles.skills}>
          <ul className={styles.skillsList}>
            <li>Java, JavaScript, PHP</li>
            <li>Spring Framework, React</li>
            <li>Docker, Kubernetes, SonarQube, Jenkins</li>
            <li>Agile, CI/CD</li>
            <li>CI/CD & DevOps</li>
          </ul>
        </div>
    </div>
  );
};

export default Experience;
